
/**
 *
 * @param error
 * @param requests
 * @param callback
 * @returns {Promise <results[] | void>}
 */
function handlePromiseRequest(error, requests, callback, errorCallback) {
    return Promise.all(requests).then(callback).catch((e) => {
        if(errorCallback) {
            errorCallback(e);
        } else {
            error({statusCode: e.response.status, message: e.response.data});
        }
    })
}

export { handlePromiseRequest }
